export const legislativeStatusCategory = [
    'resolved',
    'deferred',
    'administrative',
    'active',
];
export const legislativeStatusOutcome = ['pass', 'fail', 'cancel'];
/** Display labels for {@link LegislativeStatusCategory} values. */
export const legislativeStatusCategoryLabels = {
    resolved: 'Resolved',
    deferred: 'Deferred',
    administrative: 'Administrative',
    active: 'Active',
};
/** Display labels for {@link LegislativeStatusOutcome} values. */
export const legislativeStatusOutcomeLabels = {
    pass: 'Pass',
    fail: 'Fail',
    cancel: 'Cancel',
};
export const legislativeItemSystemStatusLabels = {
    draft: 'Draft',
    review: 'Review',
    deliberation: 'Deliberation',
    processing: 'Processing',
    closed_rejected: 'Closed - Rejected',
    closed_approved: 'Closed - Approved',
    closed_cancelled: 'Closed - Cancelled',
};
const legislativeStatuses = [
    {
        name: 'Adopted',
        code: 'ADOPTED',
        category: 'resolved',
        outcome: 'pass',
        description: 'The item has been adopted by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Approved',
        code: 'APPROVED',
        category: 'resolved',
        outcome: 'pass',
        description: 'The item has been approved by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Authorized',
        code: 'AUTHORIZED',
        category: 'resolved',
        outcome: 'pass',
        description: 'The item has been authorized by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Directed',
        code: 'DIRECTED',
        category: 'resolved',
        outcome: 'pass',
        description: 'The item has been directed by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Accepted',
        code: 'ACCEPTED',
        category: 'resolved',
        outcome: 'pass',
        description: 'The item has been accepted by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Awarded',
        code: 'AWARDED',
        category: 'resolved',
        outcome: 'pass',
        description: 'The item has been awarded by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Confirmed',
        code: 'CONFIRMED',
        category: 'resolved',
        outcome: 'pass',
        description: 'The item has been confirmed by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Ratified',
        code: 'RATIFIED',
        category: 'resolved',
        outcome: 'pass',
        description: 'The item has been ratified by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Received and Filed',
        code: 'RECEIVED_AND_FILED',
        category: 'resolved',
        outcome: 'pass',
        description: 'The item has been received and filed by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Failed',
        code: 'FAILED',
        category: 'resolved',
        outcome: 'fail',
        description: 'The item has failed by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Defeated',
        code: 'DEFEATED',
        category: 'resolved',
        outcome: 'fail',
        description: 'The item has defeated by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Continued',
        code: 'CONTINUED',
        category: 'deferred',
        outcome: null,
        description: 'The item has been continued to a specific future meeting',
        isTerminal: false,
    },
    {
        name: 'Tabled',
        code: 'TABLED',
        category: 'deferred',
        outcome: null,
        description: 'The item has been tabled by the legislative body',
        isTerminal: false,
    },
    {
        name: 'Postponed Indefinitely',
        code: 'POSTPONED_INDEFINITELY',
        category: 'deferred',
        outcome: 'cancel',
        description: 'The item has been postponed indefinitely by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Referred to Staff',
        code: 'REFERRED_TO_STAFF',
        category: 'deferred',
        outcome: null,
        description: 'The item has been referred to staff by the legislative body',
        isTerminal: false,
    },
    {
        name: 'Referred to Committee',
        code: 'REFERRED_TO_COMMITTEE',
        category: 'deferred',
        outcome: null,
        description: 'The item has been referred to committee by the legislative body',
        isTerminal: false,
    },
    {
        name: 'Pulled from Agenda',
        code: 'PULLED_FROM_AGENDA',
        category: 'administrative',
        outcome: null,
        description: 'The item has been pulled from agenda by the legislative body',
        isTerminal: false,
    },
    {
        name: 'Withdrawn',
        code: 'WITHDRAWN',
        category: 'administrative',
        outcome: 'cancel',
        description: 'The item has been withdrawn by the legislative body',
        isTerminal: true,
    },
    {
        name: 'No Action Taken',
        code: 'NO_ACTION_TAKEN',
        category: 'administrative',
        outcome: null,
        description: 'The item has no action taken by the legislative body',
        isTerminal: false,
    },
    {
        name: 'Tabled From Prior Meeting',
        code: 'TABLED_FROM_PRIOR_MEETING',
        category: 'administrative',
        outcome: null,
        description: 'The item has been tabled from prior meeting by the legislative body',
        isTerminal: false,
    },
    {
        name: 'Amended',
        code: 'AMENDED',
        category: 'active',
        outcome: null,
        description: 'The pending motion has been amended and the item remains active for consideration',
        isTerminal: false,
    },
    {
        name: 'Presentation Heard',
        code: 'PRESENTATION_HEARD',
        category: 'resolved',
        outcome: 'pass',
        description: 'The presentation has been heard by the legislative body',
        isTerminal: true,
    },
    {
        name: 'Introduced',
        code: 'INTRODUCED',
        category: 'active',
        outcome: null,
        description: 'The item has been introduced on the floor and remains active for consideration',
        isTerminal: false,
    },
    {
        name: 'Reconsidered',
        code: 'RECONSIDERED',
        category: 'active',
        outcome: null,
        description: "The item's prior disposition has been reopened for reconsideration",
        isTerminal: false,
    },
    {
        name: 'Rescinded',
        code: 'RESCINDED',
        category: 'administrative',
        outcome: 'cancel',
        description: "The legislative body's prior action on the item has been rescinded",
        isTerminal: true,
    },
];
export const DEFAULT_LEGISLATIVE_STATUSES = legislativeStatuses.map((status, index) => ({
    ...status,
    orderById: index + 1,
    isActive: true,
}));
